import { render } from "./RiBell.vue?vue&type=template&id=c8403260"
import script from "./RiBell.vue?vue&type=script&lang=js"
export * from "./RiBell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiBell.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8403260"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8403260', __exports__)) {
    api.reload('c8403260', __exports__)
  }
  
  module.hot.accept("./RiBell.vue?vue&type=template&id=c8403260", () => {
    api.rerender('c8403260', render)
  })

}


export default __exports__